<template>
  <div class="camp-create">
    <div class="create-card">
      <div class="form-row">
        <div class="form-label"><i>*</i>任务类型</div>
        <div class="type-group">
          <div
            class="type-item"
            :class="{ cur: type === item.key }"
            v-for="item in types"
            :key="item.key"
            @click="changeType(item.key)"
          >
            <i class="radio"></i>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
      <!-- 关联课程 -->
      <div class="form-row" v-if="type === 'course'" @click="openCourse">
        <div class="form-label"><i>*</i>关联课程</div>
        <div class="form-value" :class="{ picked: courseText }">
          <span>{{ courseText || '选择课程' }}</span>
          <i class="chevron"></i>
        </div>
      </div>
      <div class="form-row" v-if="type === 'exam'">
        <div class="form-label"><i>*</i>考试名称</div>
        <input class="form-input" v-model="examName" maxlength="60" placeholder="请输入考试名称">
      </div>
      <!-- 已选题目：名称、标签、编号、分值加减 -->
      <div class="form-row" v-if="type === 'exam'" @click="openQuestions">
        <div class="form-label"><i>*</i>考试题目<span v-if="chosenQuestions.length">&nbsp;{{ chosenQuestions.length }}道</span></div>
        <div class="form-value">
          <span>{{ chosenQuestions.length ? '重新选题' : '请选择' }}</span>
          <i class="chevron"></i>
        </div>
      </div>
      <div class="exam-list" v-if="type === 'exam' && chosenQuestions.length">
        <div class="exam-q" v-for="item in chosenQuestions" :key="item.key">
          <div class="exam-q-top">
            <div class="exam-q-title">{{ item.title }}</div>
            <div class="stepper" @click.stop>
              <button type="button" @click="changeScore(item, -1)">-</button>
              <input
                type="text"
                inputmode="numeric"
                :value="item.score"
                @focus="$event.target.select()"
                @input="setScore(item, $event)"
              >
              <button type="button" @click="changeScore(item, 1)">+</button>
            </div>
          </div>
          <div class="exam-q-meta">
            <span class="q-tag">{{ item.tag }}</span>
            <span class="q-code">{{ item.code }}</span>
          </div>
        </div>
        <div class="exam-total">合计：{{ totalScore }}分<span v-if="totalScore !== 100">（必须等于100）</span></div>
      </div>
      <!-- 消息：选择模版、输入框、字数 -->
      <div class="form-row" v-if="type === 'message'">
        <div class="form-label"><i>*</i>消息内容</div>
        <button class="template-link" type="button" @click="openTemplates">
          选择模版
        </button>
      </div>
      <div class="message-box" v-if="type === 'message'">
        <textarea v-model="message" maxlength="200" placeholder="请输入消息内容"></textarea>
        <div class="message-count">{{ message.length }}/200</div>
      </div>
      <!-- 学员可在创建时选择，也可先创建任务后再追加 -->
      <div class="form-row" @click="studentVisible = true">
        <div class="form-label">推送学员</div>
        <div class="form-value">
          <span>请选择</span>
          <i class="chevron"></i>
        </div>
      </div>
      <!-- 已选学员姓名，可移除 -->
      <div class="picked-list" v-if="selectedStudentRows.length">
        <div class="picked-row" v-for="item in selectedStudentRows" :key="item.id">
          <span>{{ item.name }}</span>
          <button class="picked-remove" type="button" @click="removePicked(item.id)"></button>
        </div>
      </div>
    </div>
    <div class="create-bar" v-show="!questionVisible && !courseVisible && !templateVisible">
      <button type="button" :disabled="loading" @click="submit">{{ loading ? '提交中...' : '确定' }}</button>
    </div>
    <camp-picker-page
      v-model="courseVisible"
      source="course"
      :camp-config-id="campConfigId"
      :selected-id="courseId"
      @select="pickCourse"
      @cancel="restoreCourseDraft"
      @confirm="confirmCourse"
    ></camp-picker-page>
    <!-- 选择学员 -->
    <camp-student-picker
      v-model="studentVisible"
      :students="students"
      :selected-ids="selectedStudents"
      :loading="studentLoading"
      @confirm="onStudentsConfirm"
    ></camp-student-picker>
    <!-- 选择题目 -->
    <camp-picker-page
      v-model="questionVisible"
      source="question"
      :camp-config-id="campConfigId"
      :selected-ids="pickedIds"
      @select="toggleQuestion"
      @cancel="restoreQuestionDraft"
      @confirm="confirmQuestions"
    ></camp-picker-page>
    <!-- 选择模版 -->
    <camp-picker-page
      v-model="templateVisible"
      source="template"
      :camp-config-id="campConfigId"
      @select="applyTemplate"
    ></camp-picker-page>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import CampStudentPicker from './components/CampStudentPicker.vue'
import CampPickerPage from './components/CampPickerPage.vue'
import {
  createResearchCampDispatch,
  getResearchCampDispatchStudentCandidates
} from '@/api/researchCamp'

const dispatchType = {
  course: 1,
  exam: 2,
  message: 3
}

const CampCustomTaskCreate = {
  name: 'CampCustomTaskCreate',
  components: {
    CampStudentPicker,
    CampPickerPage
  },
  data () {
    return {
      type: 'course',
      campConfigId: '',
      loading: false,
      studentLoading: false,
      types: [
        { key: 'course', label: '课程' },
        { key: 'exam', label: '考试' },
        { key: 'message', label: '消息' }
      ],
      students: [],
      courseId: '',
      coursePick: null,
      courseBackup: '',
      courseBackupText: '',
      courseBackupHospital: '',
      courseText: '',
      examName: '',
      message: '',
      selectedTemplateId: '',
      selectedTemplateTitle: '',
      selectedStudents: [],
      selectedCourseHospital: '',
      courseVisible: false,
      studentVisible: false,
      questionVisible: false,
      templateVisible: false,
      pickedIds: [],
      questionById: {},
      chosenQuestions: [],
    }
  },
  computed: {
    // 已选题目总分
    totalScore () {
      return this.chosenQuestions.reduce((sum, item) => sum + item.score, 0)
    },
    // 已选学员明细
    selectedStudentRows () {
      return this.students.filter(item => this.selectedStudents.indexOf(item.id) > -1)
    }
  },
  created () {
    this.type = this.$route.query.type || 'course'
    this.campConfigId = this.$route.query.researchCampId || this.$route.query.campConfigId || ''
    this.loadStudents()
  },
  methods: {
    // 加载可推送学员
    async loadStudents () {
      if (!this.campConfigId) {
        this.$toast('未获取到研修营信息')
        return
      }
      this.studentLoading = true
      try {
        const response = await getResearchCampDispatchStudentCandidates(this.campConfigId)
        const rows = response && Array.isArray(response.data) ? response.data : []
        this.students = rows.map(item => {
          const departmentText = item.departmentL1 || ''
          return {
            id: String(item.campMemberId),
            name: item.name || '',
            hospital: [item.hospitalName, departmentText, item.positionTitle].filter(Boolean).join(' '),
            departmentText,
            positionTitle: item.positionTitle || ''
          }
        })
      } catch (error) {
        this.students = []
        this.$toast((error && error.msg) || '候选数据加载失败')
      } finally {
        this.studentLoading = false
      }
    },
    // 切换类型后清空该类型已填内容。已选推送学员保留。
    changeType (key) {
      this.type = key
      this.courseId = ''
      this.coursePick = null
      this.courseText = ''
      this.pickedIds = []
      this.questionById = {}
      this.chosenQuestions = []
    },
    // 勾选或取消题目
    toggleQuestion (item) {
      const index = this.pickedIds.indexOf(item.id)
      if (index > -1) {
        this.pickedIds.splice(index, 1)
        this.$delete(this.questionById, item.id)
        return
      }
      this.pickedIds.push(item.id)
      this.$set(this.questionById, item.id, item)
    },
    // 打开选题，记下已确定的勾选
    openQuestions () {
      this.questionPickedBackup = this.pickedIds.slice()
      this.questionByIdBackup = Object.assign({}, this.questionById)
      this.questionVisible = true
    },
    restoreQuestionDraft () {
      this.pickedIds = (this.questionPickedBackup || []).slice()
      this.questionById = Object.assign({}, this.questionByIdBackup)
    },
    // 打开模版
    openTemplates () {
      this.templateVisible = true
    },
    // 选中的题目由服务端候选确定，分值按题目数均分到 100，余数放在最后一题。
    confirmQuestions () {
      const questions = this.pickedIds.map(id => this.questionById[id]).filter(Boolean)
      const scores = this.splitExamScores(questions.length)
      this.chosenQuestions = questions.map((item, index) => ({
        key: 'q' + item.id,
        id: item.id,
        title: item.title,
        tag: item.tag,
        code: item.code,
        score: scores[index]
      }))
    },
    // 100 分按题数均分，除不尽时前面各题取整数，余数全部加到最后一题
    splitExamScores (count) {
      if (!count) return []
      const base = Math.floor(100 / count)
      const scores = Array(count).fill(base)
      scores[count - 1] = 100 - base * (count - 1)
      return scores
    },
    // 调整单题分值
    changeScore (item, delta) {
      const next = Number(item.score) + delta
      if (next < 0 || next > 100) return
      item.score = next
    },
    // 单题分值只能是 0 到 100。
    setScore (item, event) {
      const raw = String(event.target.value).replace(/\D/g, '')
      let score = raw === '' ? 0 : parseInt(raw, 10)
      if (score > 100) score = 100
      item.score = score
      event.target.value = String(item.score)
    },
    // 移除已选学员
    removePicked (id) {
      const index = this.selectedStudents.indexOf(id)
      if (index > -1) this.selectedStudents.splice(index, 1)
    },
    // 套用模版标题和内容
    applyTemplate (item) {
      this.selectedTemplateId = item.id
      this.selectedTemplateTitle = item.name
      this.message = item.content
    },
    // 打开选课，并记住当前课程以便取消
    openCourse () {
      this.courseBackup = this.courseId
      this.courseBackupText = this.courseText
      this.courseBackupHospital = this.selectedCourseHospital
      this.courseVisible = true
    },
    pickCourse (item) {
      this.courseId = item.id
      this.coursePick = item
    },
    // 确认所选课程
    confirmCourse () {
      if (!this.coursePick || this.coursePick.id !== this.courseId) return
      this.courseText = this.coursePick.title
      this.selectedCourseHospital = this.coursePick.hospital
    },
    // 取消选课，恢复打开前的课程
    restoreCourseDraft () {
      this.courseId = this.courseBackup
      this.courseText = this.courseBackupText
      this.selectedCourseHospital = this.courseBackupHospital
    },
    // 回写已选学员
    onStudentsConfirm (ids) {
      this.selectedStudents = ids
    },
    // 考试总分必须是 100 才能提交
    async submit () {
      if (!this.campConfigId) {
        this.$toast('未获取到研修营信息')
        return
      }
      const payload = {
        contentType: dispatchType[this.type],
        campMemberIds: this.selectedStudents
      }
      if (this.type === 'course') {
        if (!this.courseId) {
          this.$toast('请选择关联课程')
          return
        }
        payload.resourceId = this.courseId
      }
      if (this.type === 'exam' && this.totalScore !== 100) {
        this.$toast('题目总分必须等于100')
        return
      }
      if (this.type === 'exam') {
        if (!this.examName.trim() || !this.chosenQuestions.length) {
          this.$toast('请填写考试名称并选择题目')
          return
        }
        if (this.chosenQuestions.some(item => Number(item.score) <= 0)) {
          this.$toast('每道题的分值必须大于0')
          return
        }
        payload.name = this.examName.trim()
        payload.questions = this.chosenQuestions.map((item, index) => ({
          questionId: item.id,
          score: Number(item.score),
          sortNo: index + 1
        }))
      }
      if (this.type === 'message') {
        if (!this.message.trim()) {
          this.$toast('请输入消息内容')
          return
        }
        const templateTitle = this.selectedTemplateTitle.trim()
        payload.name = templateTitle || this.message.trim()
        payload.messageContent = this.message.trim()
      }
      this.loading = true
      try {
        await createResearchCampDispatch(this.campConfigId, payload)
        this.$toast('创建成功')
        this.$router.replace({
          path: '/researchCamp/customTasks',
          query: { researchCampId: this.campConfigId, type: this.type }
        })
      } catch (error) {
        this.$toast((error && error.msg) || '创建失败')
      } finally {
        this.loading = false
      }
    }
  }
}

export default withRouteTracking(CampCustomTaskCreate)
</script>

<style lang="less" scoped>
@import './camp.less';

.camp-create {
  .camp-page();
  padding-top: 12px;
  padding-bottom: 90px;

  .create-card {
    .camp-white-card();
    padding: 0 14px 0 16px;
  }

  .form-row {
    display: flex;
    align-items: center;
    height: 50px;
    border-top: 1px solid #e8e8e8;

    &:first-child {
      border-top: 0;
    }
  }

  .form-label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #000;
    flex-shrink: 0;

    i {
      margin-right: 4px;
      color: @camp-red;
      font-style: normal;
    }
  }

  .type-group {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .type-item {
    display: flex;
    align-items: center;
    margin-left: 16px;
    font-size: 14px;
    line-height: 20px;
    color: #81766f;

    &:first-child {
      margin-left: 0;
    }

    &.cur {
      color: @camp-red;
    }
  }

  .radio {
    position: relative;
    width: 13px;
    height: 13px;
    margin-right: 4px;
    border: 1px solid #d3cdcd;
    border-radius: 50%;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .cur .radio,
  .radio.cur {
    border-color: @camp-red;

    &::after {
      content: '';
      position: absolute;
      left: 2px;
      top: 2px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: @camp-red;
    }
  }

  .form-value {
    display: flex;
    align-items: center;
    margin-left: auto;
    min-width: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #81766f;

    span {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.picked {
      color: #000;
    }
  }

  .chevron {
    width: 6px;
    height: 6px;
    margin-left: 6px;
    border-top: 1px solid #7a8494;
    border-right: 1px solid #7a8494;
    transform: rotate(45deg);
    flex-shrink: 0;
  }

  .form-input {
    flex: 1;
    margin-left: 12px;
    border: 0;
    background: transparent;
    font-size: 14px;
    color: #000;
    text-align: right;

    &::placeholder {
      color: #81766f;
    }
  }

  .template-link {
    margin-left: auto;
    max-width: 68%;
    padding: 0;
    border: 0;
    background: transparent;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: @camp-red;
    overflow: hidden;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .message-box {
    position: relative;
    margin: 0 0 14px;

    textarea {
      display: block;
      width: 100%;
      height: 140px;
      padding: 14px 14px 28px;
      border: 0;
      border-radius: 10px;
      box-sizing: border-box;
      background: #f9f8f7;
      font-size: 14px;
      line-height: 20px;
      color: #000;
      resize: none;

      &::placeholder {
        color: #81766f;
      }
    }
  }

  .message-count {
    position: absolute;
    right: 14px;
    bottom: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #81766f;
  }

  .exam-list {
    padding-bottom: 4px;
    border-top: 1px solid #e8e8e8;
  }

  .exam-q {
    padding: 14px 0 6px;
  }

  .exam-q-top {
    display: flex;
    align-items: flex-start;
  }

  .exam-q-title {
    flex: 1;
    min-width: 0;
    margin-right: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #000;
  }

  .stepper {
    display: flex;
    align-items: center;
    width: 80px;
    height: 24px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    flex-shrink: 0;
    overflow: hidden;

    button {
      width: 22px;
      height: 22px;
      padding: 0;
      border: 0;
      background: #fff;
      font-size: 14px;
      line-height: 22px;
      color: #000;
    }

    input {
      flex: 1;
      width: 0;
      height: 22px;
      padding: 0;
      border: 0;
      border-left: 1px solid rgba(0, 0, 0, 0.2);
      border-right: 1px solid rgba(0, 0, 0, 0.2);
      background: #fff;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #000;
    }
  }

  .exam-q-meta {
    display: flex;
    align-items: center;
    margin-top: 6px;
  }

  .q-tag {
    height: 18px;
    padding: 0 8px;
    border-radius: 10px;
    background: rgba(235, 23, 0, 0.08);
    font-size: 11px;
    font-weight: 400;
    line-height: 18px;
    color: @camp-red;
  }

  .q-code {
    margin-left: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #81766f;
  }

  .exam-total {
    padding: 8px 0 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #333;

    span {
      color: @camp-red;
    }
  }

  .picked-list {
    padding: 4px 0 8px;
    border-top: 1px solid #e8e8e8;
  }

  .picked-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 28px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #000;
  }

  .picked-remove {
    position: relative;
    width: 14px;
    height: 14px;
    margin-left: 8px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #a39992;
    flex-shrink: 0;

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 3px;
      top: 6px;
      width: 8px;
      height: 1px;
      background: #fff;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }

  .create-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 14px 13px 24px;
    background: #fff;

    button {
      width: 100%;
      height: 40px;
      border: 0;
      border-radius: 30px;
      color: #fff;
      background: @camp-red;
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/customTaskCreate.vue